<template>
  <div>
    <my-notification :icon="'warning'">
      <template #title>
        {{ $t('compTransitionDocsNotes.title') }}
      </template>
      <p>
        <b>{{ $t('compTransitionDocsNotes.title-1') }}</b
        ><br />
        <span v-html="$t('compTransitionDocsNotes.notes-1')" /> <br /><br />
        <span v-html="$t('compTransitionDocsNotes.notes-11')" /> <br /><br />
        <span v-html="$t('compTransitionDocsNotes.notes-12')" /> <br /><br />
      </p>
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'Notes',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>
